<template>
  <div class="result-check-content">
    <a-descriptions
      bordered
      v-if="crcResponse"
      v-bind="crcDescBind"
    >
      <a-descriptions-item label="打印时间">{{ crcResponse.printTime }}</a-descriptions-item>
    </a-descriptions>

    <a-descriptions
      class="mt10"
      bordered
      v-if="measureDataResponse"
      v-bind="metaDescBind"
    >
      <a-descriptions-item label="测量时间">{{ measureTime }}</a-descriptions-item>
      <a-descriptions-item label="积分时间(s)">{{ tm }}</a-descriptions-item>
      <a-descriptions-item label="分析仪">{{ analyzer }}</a-descriptions-item>
      <a-descriptions-item
        label="频率计权"
        v-if="analyzer != 'ALL' && frequencyWeight"
      >{{ frequencyWeight }}</a-descriptions-item>
      <a-descriptions-item label="时间计权" v-if="timeWeight">{{ timeWeight }}</a-descriptions-item>
      <a-descriptions-item label="统计" v-if="analyzer == 'STA'">{{ sta }}</a-descriptions-item>
      <a-descriptions-item v-if="lxdb" label="灵敏度级(dB)">{{ lxdb }}</a-descriptions-item>
      <a-descriptions-item v-if="lxmv" label="灵敏度级(mV/(m/s²))">{{ lxmv }}</a-descriptions-item>
    </a-descriptions>

    <!-- 移动端：测量项用 descriptions 列表 -->
    <a-descriptions
      v-if="measureDataResponse && layout === 'mobile'"
      class="mt10"
      bordered
      v-bind="listDescBind"
    >
      <a-descriptions-item
        v-for="item in list"
        :key="item.codeKey"
        :label="item.label"
      >{{ item.value }}</a-descriptions-item>
    </a-descriptions>

    <!-- PC 登录弹窗：测量项用宫格 -->
    <div class="check-box mt10" v-if="measureDataResponse && layout === 'modal'">
      <div class="data-item" v-for="item in list" :key="item.codeKey">
        <div class="same no-bottom-b">{{ item.label }}</div>
        <div class="same no-bottom-b1">{{ item.value }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ResultCheckContent',

  props: {
    /** modal：登录弹窗宫格；mobile：H5 页 descriptions */
    layout: {
      type: String,
      default: 'modal',
      validator: (v) => ['modal', 'mobile'].includes(v),
    },
    crcResponse: Object,
    measureDataResponse: Object,
    list: {
      type: Array,
      default: () => [],
    },
    measureTime: [String, Number],
    tm: [String, Number],
    analyzer: String,
    timeWeight: String,
    sta: String,
    frequencyWeight: String,
    lxdb: [String, Number],
    lxmv: [String, Number],
  },

  computed: {
    crcDescBind() {
      if (this.layout === 'mobile') {
        return { size: 'small', column: 1 }
      }
      return {}
    },
    metaDescBind() {
      if (this.layout === 'mobile') {
        return { size: 'small', column: 2 }
      }
      return {}
    },
    listDescBind() {
      if (this.layout === 'mobile') {
        return { size: 'small', column: 2 }
      }
      return {}
    },
  },
}
</script>

<style scoped lang="less">
.check-box {
  display: flex;
  flex-wrap: wrap;
  border-left: 1px solid #e8e8e8;
  .data-item {
    flex: 1;
  }
  .same {
    height: 30px;
    line-height: 30px;
    text-align: center;
    border: 1px solid #e8e8e8;
    border-left: none;
    color: #111;
    &.no-bottom-b {
      border-bottom: none;
      background: #fafafa;
    }
    &.no-bottom-b1 {
      margin-bottom: -1px;
    }
  }
}
</style>
